import {
  params,
  string as stringType,
  bool as boolType,
  shape as shapeType,
  arrayOf as arrayType,
  useDataModel,
} from '@thd-nucleus/data-sources';
import itemIdMapping from '../utils/online_rental_tool_info_mapping_itemId.json';

export function makeDetailKey(categoryCd, subCategoryCd) {
  const normalizedCategoryCd = String(categoryCd ?? '').trim();
  const normalizedSubCategoryCd = String(subCategoryCd ?? '').trim();
  if (!normalizedCategoryCd || !normalizedSubCategoryCd) return null;
  return `${normalizedCategoryCd}-${normalizedSubCategoryCd.padStart(3, '0')}`;
}

export function getItemIdForUsedProduct(item) {
  const key = makeDetailKey(item?.CategoryCd, item?.SubCategoryCd);
  if (!key) return null;
  return itemIdMapping[key] ?? null;
}

export const usedProductDetailDataModel = {
  product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
    itemId: stringType(),
    identifiers: shapeType({
      brandName: stringType(),
      productLabel: stringType(),
      modelNumber: stringType(),
      rentalCategory: stringType(),
      rentalSubCategory: stringType(),
      canonicalUrl: stringType(),
    }),
    media: shapeType({
      image: shapeType({
        url: stringType()
      }).client(),
      images: arrayType(
        shapeType({
          url: stringType(),
          type: stringType(),
          subType: stringType(),
          sizes: arrayType(stringType()),
        })
      ),
    }),
    details: shapeType({
      description: stringType(),
      highlights: arrayType(stringType()),
      descriptiveAttributes: arrayType(
        shapeType({
          name: stringType(),
          value: stringType(),
          bulleted: boolType(),
          sequence: stringType(),
        })
      ),
      infoAndGuides: arrayType(
        shapeType({
          name: stringType(),
          url: stringType(),
        })
      ),
    }),
  }),
};

export function useUsedProductDetailByItemId(itemId) {
  const { data, loading, error } = useDataModel('product', {
    variables: { itemId, dataSource: 'catalog' },
    skip: !itemId
  });

  return {
    detail: data?.product ?? null,
    loading,
    error: error?.message ?? null,
  };
}
